import Router from "next/router";
import { useState, useEffect } from "react";

const Bookx = () => {

  useEffect(() => {
    Router.push("/bookx");
  }, []);
  return (<p></p>);
};


export default Bookx;
